import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { getTiposPartida } from '../../actions/tipos_partida_actions';
import { modifyTipoPartidaDeZona, addTipoPartidaDeZona, removeTipoPartidaDeZona } from '../../actions/zona_tipos_partida_actions';
import {
    openDialog, hideDialog, setSaveState
} from '../../actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class ZonaTipoPartidas extends React.Component {

    componentDidMount() {

        this.props.getTiposPartida();

    };


    modifyTipoPartida = (tipopartida) => {
        this.props.setSaveState(true);
        this.props.modifyTipoPartidaDeZona(tipopartida);
    };

    addTipoPartida = (tipopartida) => {
        this.props.setSaveState(true);
        this.props.addTipoPartidaDeZona(tipopartida);
    };

    messageError = (error) => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkTipoPartida = (tipopartida) => {

        if (this.props.tipos_partida.find(tp => (tp.descr === tipopartida.descr) && (tp.id !== tipopartida.id))) {
            this.messageError(`Ya existe un tipo de partida ${tipopartida.descr}`);
            return false;
        }

        else return true;

    };


    editTipoPartida = (tipopartida) => {

        this.props.openDialog('EditZonaTipoPartida', {
            tipopartida: tipopartida,
            tiposPartida: this.props.tipos_partida,
            alltipospartida: this.props.alltipospartida,
            elemNoCajaId: this.props.elemNoCajaId,
            okHandler: this.modifyTipoPartida,
            checkTipoPartida: this.checkTipoPartida
        }, uuidv4());
    };

    newTipoPartida = () => {

        this.props.openDialog('EditZonaTipoPartida', {
            tipopartida: {},
            tiposPartida: this.props.tipos_partida,
            alltipospartida: this.props.alltipospartida,
            elemNoCajaId: this.props.elemNoCajaId,
            okHandler: this.addTipoPartida,
            checkTipoPartida: this.checkTipoPartida
        }, uuidv4());

    };

    removeTipoPartida = (tipopartida, index) => {
        this.props.setSaveState(true);
        this.props.removeTipoPartidaDeZona(tipopartida);
    };



    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Tipo de Partidas</Typography>

                {this.props.tipos_partida && !this.props.isLoading ?
                    <NeuriteGrid
                    id="z_t"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: false, dragable: false, width: 135 },
                            { key: 'activo', name: 'Activo', type: 'bool', editable: false, dragable: false, width: 55 },
                        ]}
                        rows={this.props.tipos_partida}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newTipoPartida}
                        onEditClick={this.editTipoPartida}
                        onDeleteClick={this.removeTipoPartida}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );

    };

};

ZonaTipoPartidas.propTypes = {
    //state
    elemNoCajaId: PropTypes.number.isRequired,
    tipos_partida: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    alltipospartida: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getTiposPartida: PropTypes.func.isRequired,
    modifyTipoPartidaDeZona: PropTypes.func.isRequired,
    addTipoPartidaDeZona: PropTypes.func.isRequired,
    removeTipoPartidaDeZona: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        tipos_partida: state.zonaDetallesTipoPartida.tiposPartida,
        isLoading: state.zonaDetallesTipoPartida.isLoading,
        alltipospartida: state.tiposPartida.tipospartida,
        elemNoCajaId: state.zonaDetalles.zona.elemNoCajaId
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        getTiposPartida,
        modifyTipoPartidaDeZona,
        addTipoPartidaDeZona,
        removeTipoPartidaDeZona,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ZonaTipoPartidas));